var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardTravel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.167 5.07093H12.042V3.64215C12.042 2.84918 11.4116 2.21338 10.6253 2.21338H6.37533C5.58908 2.21338 4.95866 2.84918 4.95866 3.64215V5.07093H2.83366C2.04741 5.07093 1.41699 5.70673 1.41699 6.4997V14.358C1.41699 15.1509 2.04741 15.7867 2.83366 15.7867H14.167C14.9532 15.7867 15.5837 15.1509 15.5837 14.358V6.4997C15.5837 5.70673 14.9532 5.07093 14.167 5.07093ZM6.37533 3.64215H10.6253V5.07093H6.37533V3.64215ZM14.167 14.358H2.83366V12.9292H14.167V14.358ZM14.167 10.786H2.83366V7.21409C2.83366 6.82118 3.15241 6.4997 3.54199 6.4997H4.95866V7.21409C4.95866 7.607 5.27741 7.92848 5.66699 7.92848C6.05658 7.92848 6.37533 7.607 6.37533 7.21409V6.4997H10.6253V7.21409C10.6253 7.607 10.9441 7.92848 11.3337 7.92848C11.7232 7.92848 12.042 7.607 12.042 7.21409V6.4997H13.4587C13.8482 6.4997 14.167 6.82118 14.167 7.21409V10.786Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardTravel);
export default __webpack_public_path__ + "static/media/CardTravel.304eec6240fdcbff56c72656d27e008f.svg";
export { ForwardRef as ReactComponent };